/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React, { useEffect } from "react";
import summaryStyle from "./summaryStyle";
import Grid from "@mui/material/Grid";
import { useLocation } from "react-router-dom";
import Paper from "@mui/material/Paper";
import TextContainer from "../../Container/TextContainer";
import ContactData from "./Summary/ContactData";
import PersonData from "./Summary/PersonalData";
import CommonAddress from "./Summary/CommonAddress";
import Divorce from "./Summary/Divorce";
import Financial from "./Summary/Financial";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import TextField from "@mui/material/TextField";
import { getCaseLink } from "../../../services/productService";
import { useForm } from "../../../provider/Form/FormProvider";
import { formValue } from "../../../services/formServiceFunctions";
import Typography from "@mui/material/Typography";
import { translate } from "../../../services/translations/translations";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import FormSubmitProps from "../../../types/FormSubmitProps";
import { Box } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

type SummaryProps = {
  product: AbstractCase;
  submitProps: FormSubmitProps;
};
export default function Summary({ product, submitProps }: SummaryProps) {
  const location = useLocation();
  const stateField = location.state?.field;
  const { values, handleChange, handleSubmit } = useForm();

  useEffect(() => {
    const el = document.getElementById(stateField);
    el && el.scrollIntoView();
  }, [stateField]);

  const basePath = getCaseLink(product) + "/antrag";
  return (
    <Paper elevation={4}>
      <TextContainer>
        <Typography variant={"h4"} sx={summaryStyle.headline}>
          Ihre Angaben
        </Typography>
        <Grid container>
          <Box id={"divorce"} sx={summaryStyle.scrollToAnchor} />
          <Divorce basePath={basePath} product={product} />
          <Box id={"financial"} sx={summaryStyle.scrollToAnchor} />
          <Financial basePath={basePath} product={product} />
          <Box id={"partnerData"} sx={summaryStyle.scrollToAnchor} />
          <PersonData
            title={"Angaben zum Ehepartner"}
            personType={"partner"}
            formPath={basePath + "/angaben-partner"}
            section={"partnerData"}
            product={product}
          />
          <Box id={"personalData"} sx={summaryStyle.scrollToAnchor} />
          <PersonData title={"Persönliche Angaben"} personType={"client"} formPath={basePath + "/ihre-angaben"} section={"personalData"} product={product} />
          <Box id={"commonAddress"} sx={summaryStyle.scrollToAnchor} />
          <CommonAddress formPath={basePath + "/ihre-angaben"} product={product} />
          <Box id={"contactData"} sx={summaryStyle.scrollToAnchor} />
          <ContactData formPath={basePath + "/ihre-angaben"} product={product} />
        </Grid>

        <form onSubmit={handleSubmit}>
          <TextField
            sx={summaryStyle.questionsTextArea}
            label={translate("divorce.personalTextMessage.label", values)}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Sie können uns gerne hier bereits Fragen oder Themen mitteilen, über die Sie sprechen möchten. Alle Antworten erhalten Sie dann direkt im persönlichen Telefonat."
            name="personalTextMessage"
            value={formValue(values, "personalTextMessage")}
            onChange={handleChange}
            multiline
            rows="12"
            maxRows="12"
            margin="normal"
            fullWidth
          />
          <FormSubmit
            {...submitProps}
            hideBackButton={false}
            backLink={getCaseLink(product) + "/antrag/ehe-und-scheidung"}
            backText="Alles bearbeiten"
            nextText="Angaben speichern"
            nextButtonSubtext={
              <small>
                <LockIcon sx={{ height: "12px", width: "12px", paddingTop: "2px" }} /> SSL-zertifiziert - Wir schützen Ihre Daten!
              </small>
            }
          />
        </form>
      </TextContainer>
    </Paper>
  );
}
